"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/root.component.ts');
const material_1 = require("@angular/material");
const app_service_1 = require("./commons/app.service");
const core_1 = require("@ngx-translate/core");
const loading_spinner_1 = require("./commons/ui/loading-spinner");
const identify_interface_1 = require("./xs/interfaces/identify.interface");
const router_1 = require("@angular/router");
class RootComponent {
    constructor(router, mdIconRegistry, service, translate) {
        this.router = router;
        this.service = service;
        this.__ID = null;
        DEBUG_1.DEBUG.log('/app/root.component.ts');
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        // console.log ( '%c /app/root.component.ts CONSTRUCTOR', 'color:white;background-color:black;' );
        // when using material, register fontawesome
        // mdIconRegistry.registerFontClassAlias('fontawesome', 'fa')
        // Init translation services
        let codes = [];
        service.languages.forEach(lang => codes.push(lang.code));
        translate.addLangs(codes);
        translate.setDefaultLang('en');
        let browserLang = translate.getBrowserLang();
        // console.log("Browser lang: " + browserLang)
        this.service.language = browserLang;
        translate.use(browserLang.match(/en|es|ja/) ? browserLang : 'en');
        // this bit kicks of a CSS transition from gray to blue background color 
        // (indicating that the framework is loaded, now the app and Vasat stuff needs loading)
        loading_spinner_1.LoadingSpinner.go('app');
    }
}
exports.RootComponent = RootComponent;
/*
@Component({
    selector: 'app-root',
    template: '<div id="root" [class]="service.curThemeClass"><router-outlet></router-outlet></div>'
})
export class AppMakerComponent {

    constructor(mdIconRegistry: MatIconRegistry, public service:AppService, translate: TranslateService ) {

        DEBUG.log( '/app/maker.component.ts' );

        let codes:string[] = []
        service.languages.forEach(lang => codes.push(lang.code))
        translate.addLangs(codes)
        translate.setDefaultLang('en')

        let browserLang = translate.getBrowserLang()
        // console.log("Browser lang: " + browserLang)
        this.service.language = browserLang;
        translate.use(browserLang.match(/en|es|ja/) ? browserLang : 'en')

        // this bit kicks of a CSS transition from gray to blue background color
        // (indicating that the framework is loaded, now the app and Vasat stuff needs loading)
        LoadingSpinner.go('app');
    }
}
*/
class NotFoundComponent {
    constructor() {
        DEBUG_1.DEBUG.log('/app/maker.component.ts', 'NOT FOUND COMPONENT');
        loading_spinner_1.LoadingSpinner.error();
    }
}
exports.NotFoundComponent = NotFoundComponent;
